// import { useUI } from "../contexts/UIContext";
// // import ModalXDarkSVG from "../assets/modalX_Dark.svg";
// // import ModalXLightSVG from "../assets/modalX_Light.svg";

// const GetModalX_FlowDiagram = () => {
//   const { currentTheme } = useUI(); // Get the current theme from context
//   // const ModalXLightSVG = require("../assets/ModalX_-_Black_Gradient-removebg.png")
//   const ModalXLightSVG = require("../assets/ModalX_WorkFlowDiagram.png")
//   const ModalXDarkSVG = require("../assets/Modal_X_-_B_W-removebg.png")
//   const ModalxWorkFlowDiagram_900 = require("../assets/ModalX_WorkFlowDiagram(900).png");
//   // Determine the SVG source based on the current theme
//   const svgSrc = currentTheme === "light" ? ModalXDarkSVG : ModalXLightSVG;

//   return svgSrc;
// };

// export default GetModalX_FlowDiagram;


import React, { useState, useEffect } from "react";
import { useUI } from "../contexts/UIContext";
import { useMediaQuery } from "react-responsive";

const GetModalX_FlowDiagram = () => {
  const isXsOrSm = useMediaQuery({ maxHeight: 1000 });
  const { currentTheme } = useUI();
  const [svgSrc, setSvgSrc] = useState('');

  const ModalXLightSVG = require("../assets/ModalX_WorkFlowDiagram.png");
  const ModalXDarkSVG = require("../assets/Modal_X_-_B_W-removebg.png");
  const ModalxWorkFlowDiagram_900 = require("../assets/ModalX_WorkFlowDiagram(900).png");

  useEffect(() => {
    if (isXsOrSm) {
      setSvgSrc(ModalxWorkFlowDiagram_900);
    } else {
      setSvgSrc(currentTheme === "light" ? ModalXDarkSVG : ModalXLightSVG);
    }
  }, [isXsOrSm, currentTheme]);

  return <img src={svgSrc} alt="Modal Diagram" style={{ maxWidth: '609px', height: 'auto',maxHeight:'700px'}} />;
};

export default GetModalX_FlowDiagram;

